import i18next from 'i18next';
import { SalesforceObjectName } from '../../../../../utils/objectTypes';
import { ApprovalRequestTableItem } from './mappings';

export const processRequestName = (
  request: ApprovalRequestTableItem,
): string => {
  if (
    request.relatedRecordApiName === SalesforceObjectName.ShiftChangeRequest
  ) {
    return i18next.t('schedulerShifts.shiftChangeRequest.title');
  }
  return request.relatedRecordName;
};
